import { Spine } from '@esotericsoftware/spine-pixi-v7';
import * as PIXI from 'pixi.js';

export class SpineObject extends PIXI.Container {
  constructor(skeletonAlias, atlasAlias, x = 0, y = 0) {
    super();
    // Create Spine instance using aliases
    this.spine = Spine.from({
      skeleton: skeletonAlias,
      atlas: atlasAlias,
    });
    this.spine.x = x;
    this.spine.y = y;
    this.addChild(this.spine);

    // Log available animations
    const animations = this.spine.state.data.skeletonData.animations.map(a => a.name);
    console.log('Available animations:', animations);
  }
} 